'use strict';


var keys     = require('stb-keys'),
    debounce = require('cjs-debounce'),

    Panel  = require('mag-component-panel'),
    Scroll = require('stb-component-scrollbar'),

    List = require('../settings.list.js'),

    actions = require('../../modules/application.api').actions,

    Option          = require('../../modules/models/option'),
    contentProvider = require('../../modules/content.provider'),
    listItemRender  = require('../../modules/renders/list.item'),

    footer     = require('./footer'),
    popupMenu  = require('./popup.menu'),
    rightPanel = require('./right.panel'),

    $amountContainer = document.createElement('div'),
    $amount          = $amountContainer.appendChild(document.createElement('div')),

    panel = new Panel({
        title: [{value: gettext('Settings'), className: 'name'}, $amountContainer],
        main: true,
        children: [],
        className: 'middlePanel'
    }),
    scroll = new Scroll(),

    currentSectionId = 'root',

    navigationHistory = [],
    lists             = [],
    filters           = {},

    currentList = null,

    isAdvancedSettingsEnabled = false,
    restoreFooterOnMenuHide   = false,
    // rightPanel                = null,

    setInfo = debounce(function ( config ) {
        rightPanel.setInfo(config);
    }, core.environment.onFocusDebounceTimeout),

    footerConfig;


function getDataForSection ( section ) {
    var leftPanel = require('./left.panel'),
        data = [],
        content, index, size;


    // console.log('getDataForItem: ' + (section ? section.id : 'root'));

    // console.log('push ' + section);

    if ( section && section.id !== 'root' ) {
        navigationHistory.push(section);
        data.push({
            id: 'back',
            onclick: function () {
                panel.back();
            },
            name: '..',
            description: gettext('Back to the previous list'),
            icon: 'theme-icon-back',
            render: listItemRender
        });
        currentSectionId = section.id;
    } else {
        //console.log(navigationHistory.length);
        //while ( navigationHistory.length ) {
        //    navigationHistory.pop();
        //}
        currentSectionId = 'root';
    }

    console.log('currentFilter ' + filters[currentSectionId]);
    console.log('isAdvancedSettingsEnabled ' + isAdvancedSettingsEnabled);

    leftPanel.setSearchQuery(filters[currentSectionId]);

    if ( filters[currentSectionId] ) {
        content = contentProvider.getContent(currentSectionId, function ( item ) {
            if ( isAdvancedSettingsEnabled && item.advanced ) {
                return true;
            }

            return item.name.toLowerCase().indexOf(filters[currentSectionId]) !== -1;
        });
    } else if ( isAdvancedSettingsEnabled ) {
        content = contentProvider.getContent(currentSectionId);
    } else {
        content = contentProvider.getContent(currentSectionId, function ( item ) {
            return !item.advanced;
        });
    }

    if ( content.length === 0 ) {
        data = [];
        $amount.innerText = 0;
    } else {
        size = content.length;
        index = 0;

        while ( index < size ) {
            data.push(content[index]);
            ++index;
        }

        $amount.innerText = content.length;
    }


    /*
    if ( currentFilterName ) {
        contentProvider.getContent(currentSectionId).forEach(function (item) {
            if ( item.name.toLowerCase().indexOf(currentFilterName) !== -1 ) {
                data.push(item);
            }
        });
    } else if ( isAdvancedSettingsEnabled ) {
        contentProvider.getContent(currentSectionId).forEach(function ( item ) {
            data.push(item);
        });
    } else {
        contentProvider.getContent(currentSectionId).forEach(function ( item ) {
            if ( !item.advanced ) {
                data.push(item);
            }
        });
    }
     */

    if ( section ) {
        section.options = [];

        // set inner options to
        size = data.length;
        index = 0;

        while ( index < size ) {
            if ( data[index].type === 'option' ) {
                section.options.push(data[index]);
                data[index].section = section;
            }

            ++index;
        }
    }

    return data;
}


if ( TARGET === 'android-stb' ) {
    footerConfig = {
        label: {
            code: keys.menu,
            title: gettext('Hold OK button to save new settings'),
            action: function () {
                setTimeout(function () {
                    popupMenu.show();
                }, 0);
            }
        }
    };
} else {
    footerConfig = {
        middle: [
            {
                code: keys.f1,
                title: gettext('Apply'),
                action: function () {
                    panel.save();
                }
            }
        ],
        left: {
            code: keys.menu,
            action: function () {
                popupMenu.show();
            }
        }
    };
}


$amountContainer.className = 'amountContainer';
$amount.className = 'amount';
$amount.innerText = '0';


panel.list = currentList = new List({
    propagate: true,
    cycle: false,
    focusIndex: 0,
    size: 7,
    data: [],
    scroll: scroll,
    events: {
        'focus:item': function ( event ) {
            var item = event.$curr.data;

            if ( item instanceof Option && item.events.focus ) {
                item.emit('focus');
            } else {
                setInfo(item);
            }
        },
        'click:item': function ( event ) {
            var item = event.$item.data;

            if ( item instanceof Option ) {
                if ( event.$item.onclick ) {
                    event.$item.onclick(true);
                } else {
                    item.emit('click');
                }
            } else if ( event.$item.data.onclick ) {
                event.$item.data.onclick();
            } else if ( event.$item.data.onenter ) {
                // section
                /* eslint no-useless-call: 0 */
                event.$item.data.onenter.call(event.$item.data, function ( error, data ) {
                    if ( error ) {
                        core.notify({
                            title: error,
                            icon: 'alert',
                            type: ''
                        });
                    } else if ( data && data.length > 0 ) {
                        // clear exists tree
                        contentProvider.clearSection(event.$item.data.id);
                        contentProvider.addContent(data);
                        event.$item.data.temp = true;
                        currentList.render(getDataForSection(event.$item.data), function () {
                            currentList.focusIndex(0);

                            currentList.scroll.init({
                                realSize: currentList.data.length,
                                value: currentList.viewIndex
                            });
                        });
                    }
                });
            } else {
                // section
                currentList.render(getDataForSection(event.$item.data), function () {
                    currentList.focusIndex(0);

                    currentList.scroll.init({
                        realSize: currentList.data.length,
                        value: currentList.viewIndex
                    });
                });
            }
        },
        focus: function () {
            // show footer if list have at least one item
            footer.instance.init(footerConfig);
        },
        change: function ( isChanged ) {
            if ( isChanged ) {
                if ( TARGET === 'android-app' ) {
                    require('../../modules/utils/confirm')(gettext('Apply new settings?'), function ( result ) {
                        console.log('result ' + result);
                        if ( result ) {
                            setTimeout(function () {
                                panel.save();
                            }, 0);
                        }
                    });
                } else {
                    footer.instance.show();
                }
            } else {
                footer.instance.hide();
            }
        }
    }
});

lists.push(currentList);

currentList.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            event.stop = panel.back();
            break;

        default:
            break;
    }
});

panel.add(currentList, currentList.scroll);

panel.setData = function ( data, callback ) {
    data.forEach(function ( pluginData ) {
        if ( pluginData.sections && pluginData.sections.length ) {
            contentProvider.addSections(pluginData.sections);
        }

        if ( pluginData.options && pluginData.options.length ) {
            contentProvider.addOptions(pluginData.options);
        }

        if ( pluginData.content && pluginData.content.length ) {
            contentProvider.addContent(pluginData.content);
        }
    });

    currentList.render(getDataForSection(), function () {
        panel.focus();
        currentList.focusIndex(0);

        currentList.scroll.init({
            realSize: currentList.data.length,
            value: currentList.viewIndex
        });

        callback();
    });
};


panel.save = function () {
    var requirements = currentList.getSaveRequirements(),
        reloadMessage, reloadAction;

    if ( requirements.reload ) {
        if ( requirements.reload.device ) {
            reloadMessage = gettext('To save new settings, the device should be reloaded');
            reloadAction = actions.reboot;
        } else if ( requirements.reload.portal ) {
            reloadMessage = gettext('To apply new settings, the portal should be reloaded.');
            reloadAction = actions.reload;

            if ( PLATFORM === 'SMARTTV' || PLATFORM === 'TIZEN' || PLATFORM === 'WEBOS' ) {
                reloadMessage = gettext('Restart the application to apply new settings.');
            }
        }

        core.notify({
            title: reloadMessage,
            icon: 'alert',
            type: '',
            buttons: [
                {
                    value: gettext('Cancel')
                },
                {
                    value: gettext('Ok'),
                    click: function () {
                        currentList.save(function () {
                            footer.instance.hide();

                            reloadAction();
                        });
                    }
                }
            ]
        });
    } else {
        currentList.save(function () {
            footer.instance.hide();
        });
    }

};


/**
 * Method used in page navigation.
 *
 * @return {boolean} false if panel in root of list
 */
panel.back = function () {
    var openedSection, focusIndex;

    if ( currentList.empty ) {
        return false;
    }

    if ( currentSectionId === 'root' ) {
        return false;
    }

    openedSection = navigationHistory.pop();

    if ( openedSection && openedSection.temp ) {
        contentProvider.clearSection(openedSection.id);
    }

    // open the parent of opened section
    currentList.render(getDataForSection(navigationHistory.pop()), function () {
        focusIndex = currentList.data.indexOf(openedSection);
        if ( focusIndex === -1 ) {
            currentList.focusIndex(0);
            focusIndex = 0;
        } else {
            currentList.focusIndex(focusIndex);
            if ( focusIndex - currentList.size >= 0 ) {
                focusIndex -= currentList.size;
            }
        }

        currentList.scroll.init({
            realSize: currentList.data.length,
            value: focusIndex
        });
    });

    return true;
};


panel.reset = function () {
    while ( panel.back() ) {
        // console.log('back');
    }

    // reset filters
    filters = {};
};


panel.refresh = function () {
    currentList.refresh();
};


panel.init = function ( config ) {
    var parent;

    if ( currentSectionId === 'root' ) {
        currentList.initialize(null, config);
    } else {
        parent = config.data[0].parent;
        contentProvider.clearSection(parent);
        contentProvider.addContent(config.data);
        // console.log(config.data[0].parent);
        config.data = contentProvider.getContent(parent);

        currentList.initialize({
            id: 'back',
            onclick: function () {
                panel.back();
            },
            name: '..',
            description: gettext('Back to the previous list'),
            icon: 'theme-icon-back',
            render: listItemRender
        }, config);
    }
};


/**
 * Filter content on current level by name.
 *
 * @param {Object} config - filter config
 */
panel.filterContent = function ( config ) {
    var focusIndex = currentList.viewIndex;

    if ( currentList.$focusItem ) {
        focusIndex = currentList.$focusItem.index;
    }

    // console.log('filterContent');
    // console.log(JSON.stringify(config));

    if ( config.name && config.name.length > 0 ) {
        filters[currentSectionId] = config.name.toLowerCase();
        currentList.render(getDataForSection({
            id: currentSectionId
        }), function () {
            navigationHistory.pop();
            // currentList.focusIndex(0);

            currentList.scroll.init({
                realSize: currentList.data.length,
                value: currentList.viewIndex
            });
            console.log(currentList.data.length);
            console.log('focusIndex ' + focusIndex);
            if ( focusIndex > currentList.data.length ) {
                currentList.focusIndex(0);
            } else {
                currentList.focusIndex(focusIndex);
            }
        });
    } else {
        if ( typeof config.name !== 'undefined' && config.name.length === 0 ) {
            filters[currentSectionId] = null;
        }
        isAdvancedSettingsEnabled = !!config.advanced;
        currentList.render(getDataForSection({
            id: currentSectionId
        }), function () {
            navigationHistory.pop();
            // currentList.focusIndex(0);

            currentList.scroll.init({
                realSize: currentList.data.length,
                value: currentList.viewIndex
            });

            if ( focusIndex > currentList.data.length ) {
                currentList.focusIndex(0);
            } else {
                currentList.focusIndex(focusIndex);
            }
        });
    }
};


if ( TARGET === 'android-stb' ) {
    popupMenu.addListener('show', function () {
        if ( footer.instance.visible ) {
            restoreFooterOnMenuHide = true;
            footer.instance.hide();
        }
    });

    popupMenu.addListener('hide', function () {
        if ( restoreFooterOnMenuHide ) {
            restoreFooterOnMenuHide = false;
            footer.instance.show();
        }
    });
}


module.exports = panel;
